module.exports = __webpack_public_path__ + "static/showreel_2024_clip-c0c107affb5a1dbc0f4165ae2bf1b687.mp4";